import React from 'react';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import Home from "./assets/pages/Home"
import About from "./assets/pages/About"
import Contact from "./assets/pages/Contact"
import Blog from "./assets/pages/Blog"
import Services from "./assets/pages/Services"
import './assets/css/vagadent.css'

function App(props) {
    return (
        <BrowserRouter basename={process.env.PUBLIC_URL}>
            <Routes>
                <Route path="/" element={<Home/>}/>
                <Route path="/about" element={<About/>}/>
                <Route path="/services" element={<Services/>}/>
                <Route path="/blog" element={<Blog/>}/>
                <Route path="/contact" element={<Contact/>}/>
            </Routes>
        </BrowserRouter>
    );
}

export default App;



//https://www.hiclipart.com/free-transparent-background-png-clipart-gozca/download